import type { ComponentType } from "react";
import {
  AdministrativoAvatar,
  CommunityManagerAvatar,
  ComercialAvatar,
  EditorVideoAvatar,
  RecepcionistaAvatar,
} from "./Avatars";

/**
 * Lo que comparten la seccion de empleados, el slide del hero y el modal de
 * contratacion: que avatar y que tono (hue HSL) tiene cada puesto. El id es el
 * de t.virtualTeam.members en el diccionario.
 */
export const EMPLOYEE_AVATARS: Record<string, ComponentType> = {
  "community-manager": CommunityManagerAvatar,
  administrativo: AdministrativoAvatar,
  comercial: ComercialAvatar,
  recepcionista: RecepcionistaAvatar,
  "editor-video": EditorVideoAvatar,
};

export const EMPLOYEE_HUE: Record<string, number> = {
  "community-manager": 320,
  administrativo: 172,
  comercial: 222,
  recepcionista: 34,
  "editor-video": 258,
};
